import {
    AbstractPmsApiService
} from "./abstract.service";

import {
    RoomAmenity
} from "../models";

export class DefaultRoomAmenityPmsApiService extends AbstractPmsApiService {

    static get $inject() {

        return super.$inject.concat(['Upload']);
    }

    constructor(http, config, eventsBroker, Upload) {

        super(http, config, eventsBroker);

        this.Upload = Upload;
    }
    /**
     * @param {Object.<string, *>} attributes
     * @returns {RoomAmenity}
     * @protected
     */
    get urlPattern() {
        return '/room-amenity(/:id)';
    }


    newModel(attributes) {

        return new RoomAmenity(attributes);

    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<RoomAmenity>}
     */

    get(params = {}) {
        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http.get(
                url, {
                    headers: this.authHeaders,
                    params,
                    ignoreLoadingBar: ignoreLB
                })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {RoomAmenity} RoomAmenity
     * @returns {Promise.<RoomAmenity>}
     */

    create(amenity) {

        const url = this.url();

        return this.Upload
            .upload({
                url: url,
                headers: this.authHeaders,
                data: amenity.toObject()
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {RoomAmenity} RoomAmenity
     * @returns {Promise.<RoomAmenity>}
     */

    update(amenity) {

        const url = this.url({
            id: amenity.id
        });

        if (amenity.image_file instanceof File) {
            return this.Upload
                .upload({
                    url: url,
                    headers: this.authHeaders,
                    data: amenity.toObjectExcept('image'),
                })
                .then(this.getModeler())
                .catch(this.getErrorHandler());

        }

        return this.http
            .put(url,
                amenity.toObjectExcept('image_file'), {
                    headers: this.authHeaders
                })
            .then(this.getModeler())
            .catch(this.getErrorHandler);
    }

    /**
     * @param {RoomAmenity} RoomAmenity
     * @returns {Promise.<boolean>}
     */

    delete(amenity) {
        const url = this.url({
            id: amenity.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());;
    }

    /**

     * @param {Integer} roomId
     * @param {Object} params
     */
    show(roomId, params = {}) {

        const url = this.url({
            id: roomId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

}


// WEBPACK FOOTER //
// ./src/pms-api/services/default-room-amenity.service.js